export { default as CtaWrapper } from './CtaWrapper';
export { default as useGetCtaWrapperContent } from './hooks/useGetCtaWrapperContent';
